/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'sarsaparilla';
import { formatItemName } from '../utils/stringUtils';

const propTypes = {
    destination: PropTypes.object,
    destinationIndex: PropTypes.number,
};

const defaultProps = {
    name: '',
};

export default class TripItineraryDeparture extends React.Component {
    render() {
        let icon = null;
        if (this.props.destinationIndex === 0) {
            icon = <Icon iconName="home" />;
        } else {
            icon = <Icon iconName="car" />;
        }

        const name = formatItemName(this.props.destination);

        return (
            <div className="trip-planner-itinerary-departure">
                <div className="trip-planner-itinerary-icon">{icon}</div>
                <div className="trip-planner-itinerary-location">
                    <span className="label">
                        DEPART{' '}
                        {this.props.destinationIndex === 0 ? '(STARTING LOCATION)' : ''}
                    </span>
                    <span>
                        <strong>{name}</strong>
                    </span>
                </div>
            </div>
        );
    }
}

TripItineraryDeparture.propTypes = propTypes;
TripItineraryDeparture.defaultProps = defaultProps;
